module.exports = __webpack_public_path__ + "static/img/mowpi-clear.773f4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mowpi-clear.png
// module id = f+C7
// module chunks = 1